import { Component } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Actions, ofType } from '@ngrx/effects';
import {
  addMeasureArea,
  addMeasureDistance,
  addMeasureFailure,
  addMeasureSuccess
} from '../../../../features/measure/measure.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  addCut,
  addCutFailure,
  addCuts,
  addCutsFailure,
  addCutsSuccess,
  addCutSuccess,
  generateCutsDXF,
  generateCutsDXFFailure,
  generateCutsDXFSuccess,
  generateCutsReport,
  generateCutsReportFailure,
  generateCutsReportSuccess,
  retrieveCutsCoordinatesCSV, retrieveCutsCoordinatesCSVFailure,
  retrieveCutsCoordinatesCSVSuccess,
} from '../../../../features/cut/cut.actions';
import {
  addTracker,
  addTrackerFailure,
  addTrackerSuccess,
  addTrackerImages,
  addTrackerImagesFailure,
  addTrackerImagesSuccess,
  addTrackerElevations,
  addTrackerElevationsSuccess,
  addTrackerElevationsFailure,
  retrieveElevationsCoordinatesCSV,
  retrieveElevationsCoordinatesCSVSuccess,
  retrieveElevationsCoordinatesCSVFailure,
  retrieveMarkersCoordinatesCSV,
  retrieveMarkersCoordinatesCSVSuccess, retrieveMarkersCoordinatesCSVFailure
} from '../../../../features/tracker/tracker.actions';
import {
  addDetection,
  addDetectionFailure,
  addDetectionSuccess,
  generateDetectionsReport,
  generateDetectionsReportFailure,
  generateDetectionsReportSuccess
} from '../../../../features/detection/detection.actions';
import { Store } from '@ngrx/store';
import {
  selectConfigIsDownloadingPicture
} from '../../../../features/config/config.selectors';
import {
  activateAdvancedFeatures,
  activateAdvancedFeaturesFailure,
  activateAdvancedFeaturesSuccess
} from '../../../../features/site/site.actions';
import {
  addTilesetConfig, addTilesetConfigFailure,
  addTilesetConfigSuccess
} from '../../../../features/tileset-config/tileset-config.actions';
import {
  generateVolumesDXF, generateVolumesDXFFailure, generateVolumesDXFSuccess
} from '../../../../features/volume/volume.actions';

@Component({
    selector: 'compute-loader',
    templateUrl: './compute-loader.component.html',
    styleUrls: ['./compute-loader.component.scss'],
    animations: [
        trigger('inOutAnimation', [
            state('in', style({
                transform: 'translateY(0)',
                opacity: 1
            })),
            state('out', style({
                transform: 'translateY(100px)',
                opacity: 0
            })),
            transition('in <=> out', [
                animate('150ms ease-out')
            ])
        ])
    ],
    standalone: false
})
export class ComputeLoaderComponent {
  isComputing: boolean = false;

  constructor(private store: Store,private actions: Actions) {
    this.initHandleActions();
    this.store.select(selectConfigIsDownloadingPicture)
      .pipe(takeUntilDestroyed())
      .subscribe((isDownloading: boolean) => {
        this.isComputing = isDownloading;
    });
  }

  private initHandleActions() {
    this.actions.pipe(
      ofType(
        addDetection,
        addMeasureDistance,
        addMeasureArea,
        addCut,
        addCuts,
        addTracker,
        addTrackerImages,
        addTrackerElevations,
        generateCutsDXF,
        generateCutsReport,
        generateDetectionsReport,
        activateAdvancedFeatures,
        retrieveCutsCoordinatesCSV,
        retrieveElevationsCoordinatesCSV,
        retrieveMarkersCoordinatesCSV,
        addTilesetConfig,
        generateVolumesDXF),
      takeUntilDestroyed())
      .subscribe(result => {
        this.isComputing = true;
      });

    this.actions.pipe(
      ofType(
        addDetectionSuccess, addDetectionFailure,
        addMeasureSuccess, addMeasureFailure,
        addCutSuccess, addCutFailure,
        addCutsSuccess, addCutsFailure,
        addTrackerSuccess, addTrackerFailure,
        addTrackerImagesSuccess, addTrackerImagesFailure,
        addTrackerElevationsSuccess, addTrackerElevationsFailure,
        generateCutsDXFSuccess, generateCutsDXFFailure,
        generateCutsReportSuccess, generateCutsReportFailure,
        generateDetectionsReportSuccess, generateDetectionsReportFailure,
        activateAdvancedFeaturesSuccess, activateAdvancedFeaturesFailure,
        retrieveCutsCoordinatesCSVSuccess, retrieveCutsCoordinatesCSVFailure,
        retrieveElevationsCoordinatesCSVSuccess, retrieveElevationsCoordinatesCSVFailure,
        retrieveMarkersCoordinatesCSVSuccess, retrieveMarkersCoordinatesCSVFailure,
        addTilesetConfigSuccess, addTilesetConfigFailure,
        generateVolumesDXFSuccess, generateVolumesDXFFailure),
      takeUntilDestroyed())
      .subscribe(result => {
        this.isComputing = false;
      });
  }
}
